module.exports = __webpack_public_path__ + "img/EUR-logo.6da6e343.svg";